import { FormField } from 'global/components/Form'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useCredenciaisApiOutletContext } from 'pages/CredenciaisApi'
import { SubmitHandler } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import {
    UpdateApiClientInput,
    apiClients,
    updateApiClientSchema,
} from 'service/api'
import { toast } from 'sonner'
import { CredencialForm } from '../atoms/CredencialForm'

export default function EditarCredencial() {
    const { id } = useParams()
    const navigate = useNavigate()
    const { data } = useCredenciaisApiOutletContext()
    const credencial = data?.find(item => item.id === Number(id))

    const { mutateAsync, isLoading } = apiClients.mutations.useUpdate({
        invalidateQuery: true,
    })

    if (!credencial) return null

    const handleClose = () => {
        navigate('/integracoes/credenciais-api')
    }

    const handleSubmit: SubmitHandler<
        UpdateApiClientInput
    > = async formData => {
        try {
            await mutateAsync({
                ...formData,
                id: credencial.id,
            })
            toast.success('Credencial atualizada com sucesso')
            handleClose()
        } catch (err: any) {
            toast.error(err?.message || 'Erro ao atualizar credencial')
        }
    }

    return (
        <Dialog.Root
            height="auto"
            loading={isLoading}
            onSubmit={handleSubmit}
            defaultValues={{
                id: credencial.id,
                nome: credencial.nome,
                scopes: credencial.scopes,
                rateLimitRpm: credencial.rateLimitRpm,
                ativo: credencial.ativo,
            }}
            schema={updateApiClientSchema}
            open={hasPermission(['update', 'CredenciaisDeAPI'])}
            onClose={handleClose}
        >
            <Dialog.Title>Editar Credencial de API</Dialog.Title>
            <Dialog.Content dividers>
                <FormField name="id" hidden defaultValue={credencial.id} />
                <CredencialForm isEditing />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton onClick={handleClose} />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
